export default __webpack_public_path__ + "static/media/421.ca9de5a9.png";